import * as React from 'react';
import { connect } from 'react-redux';
import Modal from '../../../BasicOrderInfoModal';
import { INewEmail, ITemplate, IRecipient, ISmsFormState } from '../../../Types';
import { handleError } from '../../../../../../../shared/ErrorCatching';
import { Translate } from '../../../../../../../shared/LanguageService';
import SmsForm from './SmsForm';
import { assign } from '../../../../../../../shared/Assign';
import * as Actions from '../../../Actions';
import * as Strings from './../../Strings';
import notify from '../../../../../../../shared/feedback/notifications';

interface IActions {
    createSms: (orderId: number, formState: ISmsFormState, recipients: IRecipient[]) => any;
}

interface IProps {
    actions: IActions;
    close: () => void;
    recipients: IRecipient[];
    templates: ITemplate[];
    defaultTemplateKey: number;
    orderId: number;
}

interface IState {
    initialized: boolean;
    doing: boolean;
    formErrors: any;
    formState: ISmsFormState;
}

class SmsModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            initialized: false,
            doing: false,
            formErrors: {},
            formState: {
                recipient: 0,
                recipientType: 0,
                cc: '',
                desiredSendTime: null,
                body: '',
                template: -1
            }
        };

        this.createSms = this.createSms.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.onDateTimeChange = this.onDateTimeChange.bind(this);
        this.onSelectorChange = this.onSelectorChange.bind(this);
    }

    componentDidMount(): void {
        this.forceUpdate();
    }

    componentDidUpdate(): void {
        if (!this.state.initialized) {
            let formState: ISmsFormState = assign({}, this.state.formState);

            if (this.props.recipients.length === 1) {
                formState.recipient = 1;
            }

            let templates = this.props.templates.filter(
                (t: ITemplate) => t.key === this.props.defaultTemplateKey
            );
            if (templates.length === 1) {
                formState.template = templates[0].id;
                formState.body = templates[0].content;
            }

            let state = assign({}, this.state);
            state.formState = formState;
            state.initialized = true;
            this.setState(state);
        }
    }

    onFormChange(e: any): void {
        let formState = assign({}, this.state.formState);
        const value = e.target.value;

        formState[e.target.name] = value;

        let state = assign({}, this.state);
        state.formState = formState;
        this.setState(state);
    }

    onSelectorChange(e: any) {
        let formState = assign({}, this.state.formState);
        const value = e.target.value;

        formState[e.target.name] = Number(value);
        if (e.target.name === Strings.templateSelectorName) {
            if (value === '') {
                formState.body = '';
            } else {
                let template = this.props.templates.filter((t: ITemplate) => {
                    return t.id.toString() === value;
                })[0];
                formState.body = template.content;
            }
        }

        let state = assign({}, this.state);
        state.formState = formState;
        this.setState(state);
    }

    onDateTimeChange(moment: any): void {
        let formState = this.state.formState;

        formState.desiredSendTime = moment ? moment.toDate() : null;

        let state = assign({}, this.state);
        state.formState = formState;
        this.setState(state);
    }

    createSms(): void {
        this.props.actions
            .createSms(this.props.orderId, this.state.formState, this.props.recipients)
            .then(() => {
                notify.success(
                    Translate('view-order/basic-order/modal/create-sms/success-notification')
                );
                this.props.close();
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    let state = assign({}, this.state);
                    state.formErrors = errors;
                    this.setState(state);
                })
            );
    }

    render(): any {
        return (
            <Modal
                title="view-order/basic-order/modal/create-sms/title"
                readOnly={false}
                large={true}
                do={this.createSms}
                doText="view-order/basic-order/modal/create-sms/button-labels/do"
                close={this.props.close}
                doing={this.state.doing}
                doingText="view-order/basic-order/modal/create-sms/button-labels/doing"
                cancelText="view-order/basic-order/modal/create-sms/button-labels/cancel"
            >
                <SmsForm
                    errors={this.state.formErrors}
                    state={this.state.formState}
                    recipients={this.props.recipients}
                    templates={this.props.templates}
                    onChange={this.onFormChange}
                    onDateTimeChange={this.onDateTimeChange}
                    onSelectorChange={this.onSelectorChange}
                />
            </Modal>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        recipients: state.basicOrderInfo.newSms.recipients,
        templates: state.basicOrderInfo.newSms.templates,
        defaultTemplateKey: state.basicOrderInfo.newSms.defaultTemplateKey
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            createSms: (orderId: number, formState: ISmsFormState, recipients: IRecipient[]) =>
                dispatch(Actions.createSms(orderId, formState, recipients))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SmsModal);
